import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Footer from '../Components/Footer/Footer'
import Product from '../Components/Product.jsx/Product'

const ViewProduct = () => {
  return (
    <div>
      <Navbar/>
      <Product/>
      <Footer/>
    </div>
  )
}

export default ViewProduct
